import { Listbox } from "@headlessui/react";
import React, { useState, useEffect } from 'react';
import { Package, ChevronDown, Info, MapPin, Calendar, Clock, Box, User, Phone, CheckCircle2, Loader2 } from 'lucide-react';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import { useMyContext } from '../../../context/MyContext';
import { toast } from 'react-toastify';
import '../../../css/custom-scrollbar.css'
import { Base_Url, createpickuprequest, b2bWarehouseListAll, pickrequestList } from '../../../config/config';

const PickupDetailsPage = () => {
    const [query, setQuery] = useState("");
    const [dates, setDates] = useState([]);
    const { isDarkMode, isToggleSidebar, selectedCft } = useMyContext();
    const [warehouses, setWarehouses] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState('');
    const [selectedCourier, setSelectedCourier] = useState('');
    const [loading, setLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState(null);
    const [boxCount, setBoxCount] = useState('');
    const [selectedSlot, setSelectedSlot] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [pickupRequests, setPickupRequests] = useState([]);
    //   const [loading, setLoading] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const limitNumber = 10;

    const token = localStorage.getItem("token");
    const cus_id = localStorage.getItem("cus_id");


    useEffect(() => {
        fetchPickupRequests(currentPage);
    }, [currentPage]);

    const fetchPickupRequests = async (pageNumber) => {
        setLoading(true);
        try {
            const url = `${Base_Url}${pickrequestList}?page=${pageNumber}&limit=${limitNumber}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    cus_id: cus_id,
                    token: token,
                },
            });

            const result = await response.json();

            if (result.status === 'SUCCESS' && result.data) {
                setPickupRequests(result.data);
                setTotalPages(result.pagination.totalPages);
                setTotalItems(result.pagination.totalItems);
            } else {
                console.error('Failed to fetch pickup requests:', result.message);
                setPickupRequests([]);
            }
        } catch (error) {
            console.error('Error fetching pickup requests:', error);
            setPickupRequests([]);
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'created':
                return 'bg-blue-100 text-blue-800 border-blue-200';
            case 'pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'completed':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'cancelled':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    useEffect(() => {
        fetchWarehouses();
    }, []);


    useEffect(() => {
        setDates(generateDates());
    }, []);

    const fetchWarehouses = async () => {
        try {
            // Uncomment this for real API
            const response = await fetch(Base_Url + b2bWarehouseListAll, {
                method: "GET",
                headers: {
                    "token": token,
                    "cus_id": cus_id,
                    "Content-Type": "application/json"
                }
            });
            const data = await response.json();
            if (data.status === 'SUCCESS' && data.data) {
                setWarehouses(data.data);
            }
        } catch (error) {
            console.error('Error fetching warehouses:', error);
        } finally {
            setLoading(false);
        }
    };


    const getRandomTimeInSlot = (slot) => {
        const startHour = slot.start;
        const endHour = slot.end;

        const randomHour = Math.floor(Math.random() * (endHour - startHour)) + startHour;
        const randomMinute = Math.floor(Math.random() * 60);

        return `${String(randomHour).padStart(2, "0")}:${String(randomMinute).padStart(2, "0")}:00`;
    };


    const handleCreateRequest = async () => {
        if (!selectedSlot) {
            toast.error("Please select a pickup slot");
            return;
        }
        const slot = pickupSlots.find((s) => s.value === selectedSlot);
        if (!slot) {
            toast.error("Invalid slot");
            return;
        }
            console.log("Submitting warehouse_id:", selectedOrder); // 👈 ye add karo

        setIsSubmitting(true);
        try {
            // Convert date
            const selectedFullDate = new Date();
            selectedFullDate.setDate(selectedFullDate.getDate() + selectedDate);

            const pickupDateFormatted = selectedFullDate.toISOString().split("T")[0];

            // Generate random time inside slot
            const pickupStartTime = getRandomTimeInSlot(slot);

            const requestData = {
                warehouse_id: selectedOrder,
                pickup_date: pickupDateFormatted,
                start_time: pickupStartTime,
                retailer_id: cus_id,
                // contact_person: contactName,
                // contact_phone: contactPhone,
                box_count: parseInt(boxCount),
                courier_partner: selectedCourier,
                type: selectedCft || ''
            };
            const response = await fetch(Base_Url + createpickuprequest, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "cus_id": localStorage.getItem("cus_id"),
                    "token": localStorage.getItem("token"),
                },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();

            if (data.status === "success") {
                toast.success(data.message);
                setSelectedDate(null);
                setSelectedSlot("");
                setBoxCount("");
                // setContactName("");
                // setContactPhone("");
            } else {
                toast.error(data.message || "Failed to create pickup request");
            }
        } catch (error) {
            console.error("Error creating pickup request:", error);
            toast.error("An error occurred while creating the pickup request");
        } finally {
            setIsSubmitting(false);
        }
    };

    // ✅ selectedCft (number: 6/10/15) ko warehouse ke cft_type (text: lite/heavy/dense) se map kiya
    const cftTypeMap = { 6: "lite", 10: "heavy", 15: "dense" };

    const filteredWarehouses = warehouses.filter((warehouse) => {
        // const billing = JSON.parse(warehouse.billing_address || "{}");
        // const dropoff = JSON.parse(warehouse.dropoff_location || "{}");
        const text = `
        ${warehouse.warehouse_id}
        ${warehouse?.retailer_id}
        ${warehouse?.name}
        ${warehouse.pin_code}
    `.toLowerCase();

        const matchesSearch = text.includes(query.toLowerCase());
        const matchesCft = !selectedCft || warehouse.cft_type?.toLowerCase() === cftTypeMap[selectedCft];

        return matchesSearch && matchesCft;
    });

    const generateDates = (daysCount = 6) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        const today = new Date();
        const result = [];

        for (let i = 0; i < daysCount; i++) {
            const current = new Date();
            current.setDate(today.getDate() + i);

            result.push({
                day: i === 0 ? "Today" : days[current.getDay()],
                date: current.getDate(),
                month: months[current.getMonth()]
            });
        }

        return result;
    };

    const pickupSlots = [
        { value: 'morning', label: 'Morning (7 AM - 10 PM)', start: 7, end: 10 },
        { value: 'morning', label: 'Morning (10 AM - 2 PM)', start: 10, end: 14 },
        { value: 'evening', label: 'Evening (2 PM - 6 PM)', start: 14, end: 18 },
        { value: 'night1', label: 'Night (6 PM - 9 PM)', start: 18, end: 21 },
        { value: 'night2', label: 'Night (9 PM - 12 AM)', start: 21, end: 24 }
    ];

    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
            <div className="z-10">
                <NavBar />
            </div>

            <div className="flex flex-1 overflow-hidden">
                {isToggleSidebar && (
                    <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                        style={
                            window.innerWidth < 768
                                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                : {}
                        }>
                        <Sidebar />
                    </div>
                )}
                {/* <div className="flex-1 max-w-7xl overflow-y-auto"> */}
                <div
                    className={`flex-1 sm:mt-3 overflow-auto transition-all duration-300 custom-scrollbar  rounded-custom md:ml-4 md:mr-4 md:mr-4 md:mb-4 ${isToggleSidebar ? 'md:ml-0' : 'md:ml-0'} ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white shadow-custom-dark" : "bg-white"}`}
                >
                    <div className="grid grid-cols-1 lg:grid-cols-[1.7fr_1fr] gap-6">
                        {/* Main Form Section */}
                        <div className="lg:col-span-1">
                            <div className="bg-white rounded-custom shadow-md border border-gray-200 p-6">

                                <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-200">
                                    <div className="p-2 bg-blue-100 rounded-custom">
                                        <Package className="w-5 h-5 text-blue-600" />
                                    </div>
                                    <h2 className="text-lg font-semibold text-gray-900">Pickup Details</h2>
                                </div>

                                {/* Select Order */}
                                <div className="flex gap-4 w-full">

                                    {/* WAREHOUSE DROPDOWN — FIRST */}
                                    <div className="flex-1">
                                        <label className="text-[11px] font-semibold text-gray-700 mb-1 block">
                                            Select Warehouse
                                        </label>

                                        <div className="relative">
                                            <Listbox value={selectedOrder} onChange={setSelectedOrder}>
                                                <div className="relative">

                                                    {/* Button */}
                                                    <Listbox.Button className="w-full px-3 py-2 bg-white border border-gray-300 rounded-custom shadow-md flex justify-between items-center text-xs text-gray-900">
                                                        {selectedOrder || "Select Warehouse"}
                                                        <ChevronDown className="w-4 h-4 text-gray-400" />
                                                    </Listbox.Button>

                                                    {/* Dropdown */}
                                                    <Listbox.Options className="absolute z-50 mt-2 w-full bg-white border border-gray-200 rounded-custom shadow-md max-h-64 overflow-auto">

                                                        {/* Search Box */}
                                                        <div className="sticky top-0 bg-white p-2 border-b">
                                                            <input
                                                                type="text"
                                                                placeholder="Search Warehouse..."
                                                                value={query}
                                                                onChange={(e) => setQuery(e.target.value)}
                                                                className="w-full px-3 py-1 border rounded-custom shadow-md text-xs"
                                                            />
                                                        </div>

                                                        {/* Options */}
                                                        {filteredWarehouses.length === 0 ? (
                                                            <p className="p-3 text-xs text-gray-500 text-center">No results found</p>
                                                        ) : (
                                                            filteredWarehouses.map((warehouse) => (
                                                                <Listbox.Option
                                                                    key={warehouse.warehouse_id}
                                                                    value={warehouse.warehouse_id}
                                                                    className={({ active }) =>
                                                                        `cursor-pointer px-3 py-2 border-b last:border-none text-xs ${active ? "bg-blue-50" : ""
                                                                        }`
                                                                    }
                                                                >
                                                                    <p className="font-semibold text-gray-900">
                                                                        {warehouse.warehouse_id}
                                                                    </p>
                                                                    <p className="text-gray-600 text-[10px]">
                                                                        {warehouse.retailer_id} • {warehouse.name}
                                                                    </p>
                                                                    <p className="text-gray-600 text-[10px]">
                                                                        pin {warehouse.pin_code}
                                                                    </p>
                                                                </Listbox.Option>
                                                            ))
                                                        )}
                                                    </Listbox.Options>
                                                </div>
                                            </Listbox>

                                            {loading ? (
                                                <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 animate-spin" />
                                            ) : (
                                                <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
                                            )}
                                        </div>
                                    </div>

                                    {/* COURIER DROPDOWN — SECOND */}
                                    <div className="flex-1">
                                        <label className="text-[11px] font-semibold text-gray-700 mb-1 block">
                                            Select Courier
                                        </label>

                                        <div className="relative">
                                            <Listbox value={selectedCourier} onChange={setSelectedCourier}>
                                                <div className="relative">
                                                    <Listbox.Button className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg flex justify-between items-center text-xs text-gray-900">
                                                        {selectedCourier || "Select Courier"}
                                                        <ChevronDown className="w-4 h-4 text-gray-400" />
                                                    </Listbox.Button>

                                                    <Listbox.Options className="absolute z-50 mt-2 w-full bg-white border border-gray-200 rounded-custom shadow-md max-h-60 overflow-auto">
                                                        {["Delhivery", "XpressBees", "Gati", "BlueDart", "Ecom Express"].map((option) => (
                                                            <Listbox.Option
                                                                key={option}
                                                                value={option}
                                                                className={({ active }) =>
                                                                    `cursor-pointer px-3 py-2 border-b last:border-none text-xs ${active ? "bg-blue-50" : ""
                                                                    }`
                                                                }
                                                            >
                                                                {option}
                                                            </Listbox.Option>
                                                        ))}
                                                    </Listbox.Options>
                                                </div>
                                            </Listbox>
                                        </div>
                                    </div>

                                </div>


                                {/* Pickup Date */}
                                <div className="mb-6 mt-4">
                                    <label className="block text-xs font-medium text-gray-700 mb-2">
                                        Pickup Date
                                    </label>

                                    <div className="grid grid-cols-3 md:grid-cols-6 gap-2">
                                        {dates.map((dateInfo, index) => (
                                            <button
                                                key={index}
                                                onClick={() => setSelectedDate(index)}
                                                className={`flex flex-col items-center p-2 rounded-custom shadow-md border text-xs transition-all ${selectedDate === index
                                                    ? "border-blue-500 bg-blue-50"
                                                    : "border-gray-200 hover:border-gray-300"
                                                    }`}
                                            >
                                                <span className={`${selectedDate === index ? "text-blue-600 font-medium" : "text-gray-500"}`}>
                                                    {dateInfo.day}
                                                </span>
                                                <span className={`text-lg font-bold ${selectedDate === index ? "text-blue-600" : "text-gray-800"}`}>
                                                    {dateInfo.date}
                                                </span>
                                                <span className={`${selectedDate === index ? "text-blue-500" : "text-gray-500"}`}>
                                                    {dateInfo.month}
                                                </span>
                                            </button>
                                        ))}
                                    </div>

                                    <div className="flex items-start gap-2 mt-3 p-2 bg-amber-50 border border-amber-200 rounded-lg">
                                        <Info className="w-3 h-3 text-amber-600 mt-0.5 flex-shrink-0" />
                                        <p className="text-[10px] text-amber-800">
                                            Book before 2 PM for same-day pickup.
                                        </p>
                                    </div>
                                </div>

                                {/* Pickup Slot + Boxes */}
                                <div className="mb-6">
                                    <div className="flex flex-col md:flex-row md:items-center md:gap-6">

                                        {/* Time Slot */}
                                        <div className="flex-1 mb-5 md:mb-0">
                                            <label className="block text-xs font-medium text-gray-700 mb-2">
                                                Pickup Time Slot
                                            </label>
                                            <div className="relative">
                                                <select
                                                    value={selectedSlot}
                                                    onChange={(e) => setSelectedSlot(e.target.value)}
                                                    className="w-full px-3 py-2 bg-white border border-gray-300 rounded-custom shadow-md text-xs"
                                                >
                                                    <option value="">Select a time slot</option>
                                                    {pickupSlots.map((slot) => (
                                                        <option key={slot.value} value={slot.value}>
                                                            {slot.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                {/* <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" /> */}
                                            </div>
                                        </div>

                                        {/* Boxes */}
                                        <div className="flex-1">
                                            <label className="block text-xs font-medium text-gray-700 mb-2">
                                                Number of Boxes
                                            </label>
                                            <input
                                                type="number"
                                                value={boxCount}
                                                onChange={(e) => setBoxCount(e.target.value)}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-custom shadow-md text-xs"
                                                min="1"
                                                placeholder="Enter box count"
                                            />
                                        </div>

                                    </div>
                                </div>

                                {/* Submit */}
                                <button
                                    onClick={handleCreateRequest}
                                    disabled={isSubmitting}
                                    className={`w-full py-2 rounded-custom shadow-md font-medium text-xs ${isSubmitting
                                        ? "bg-gray-400 cursor-not-allowed text-white"
                                        : "bg-blue-600 hover:bg-blue-700 text-white"
                                        }`}
                                >
                                    {isSubmitting ? (
                                        <span className="flex items-center justify-center gap-2">
                                            <Loader2 className="w-4 h-4 animate-spin" />
                                            Creating...
                                        </span>
                                    ) : (
                                        "Create Pickup Request"
                                    )}
                                </button>

                            </div>
                        </div>

                        {/* Right Table */}
                        <div className="lg:col-span-1 w-full">
                            <div className="bg-white w-full rounded-custom shadow-md border border-gray-200 overflow-hidden">
                                <div className="p-4">
                                    {loading ? (
                                        <div className="flex flex-col items-center justify-center py-20">
                                            <Loader2 className="w-12 h-12 text-blue-500 animate-spin mb-4" />
                                            <p className="text-gray-600">Loading pickup requests...</p>
                                        </div>
                                    ) : pickupRequests.length > 0 ? (
                                        <>
                                            {/* Pickup Request Table */}
                                            <div className="overflow-x-auto max-h-[375px] overflow-y-auto custom-scrollbar">
                                                <table className="min-w-full divide-y divide-gray-200">
                                                    <thead className="bg-gray-50 sticky top-0 ">
                                                        <tr>
                                                            <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                                                                Request ID
                                                            </th>
                                                            <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                                                                Status
                                                            </th>
                                                            <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                                                                Date
                                                            </th>
                                                            <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                                                                Time
                                                            </th>
                                                            <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                                                                Boxes
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="bg-white divide-y divide-gray-200">
                                                        {pickupRequests.map((request) => (
                                                            <tr
                                                                key={request.id}
                                                                onClick={() => setSelectedRequest(request.request_id)}
                                                                className={`cursor-pointer transition-all ${selectedRequest === request.request_id
                                                                        ? "bg-blue-50"
                                                                        : "hover:bg-gray-50"
                                                                    }`}
                                                            >
                                                                <td className="px-3 py-3 text-xs font-medium text-gray-900">
                                                                    {request.request_id}
                                                                </td>
                                                                <td className="px-3 py-3">
                                                                    <span
                                                                        className={`px-2 py-1 inline-flex text-[10px] font-semibold rounded-full ${getStatusColor(
                                                                            request.status
                                                                        )}`}
                                                                    >
                                                                        {request.status}
                                                                    </span>
                                                                </td>
                                                                <td className="px-3 py-3 text-xs text-gray-900">
                                                                    {request.pickup_date}
                                                                </td>
                                                                <td className="px-3 py-3 text-xs text-gray-900">
                                                                    {request.start_time}
                                                                </td>
                                                                <td className="px-3 py-3 text-xs text-gray-900">
                                                                    {request.box_count}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>


                                            {/* Pagination */}
                                            {/* Pagination - Always visible */}
                                            <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-t border-gray-200 mt-4">
                                                <div className="text-xs text-gray-600">
                                                    Page {currentPage} of {totalPages}
                                                </div>
                                                <div className="flex gap-2">
                                                    <button
                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                        disabled={currentPage === 1}
                                                        className={`px-3 py-1 rounded-lg text-xs font-medium transition-colors ${currentPage === 1
                                                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                                            : 'bg-blue-500 text-white hover:bg-blue-600'
                                                            }`}
                                                    >
                                                        Previous
                                                    </button>
                                                    <button
                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                        disabled={currentPage === totalPages}
                                                        className={`px-3 py-1 rounded-lg text-xs font-medium transition-colors ${currentPage === totalPages
                                                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                                            : 'bg-blue-500 text-white hover:bg-blue-600'
                                                            }`}
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="flex flex-col items-center justify-center py-12">
                                            <Package className="w-12 h-12 text-gray-300 mb-3" />
                                            <p className="text-gray-600 text-sm font-medium">No pickup requests found</p>
                                            <p className="text-gray-500 text-xs mt-1">There are no pickup requests to display</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default PickupDetailsPage;